import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { v4 } from 'uuid';
import VariantItem from '~/components/Items/VariantItem';
import styles from './SingleSelect.module.scss';
import Text from '~/components/Text';
import { ProductConfigurableOptionValue } from '~/services/product';

type Options = ProductConfigurableOptionValue & { disabled?: boolean };
interface SingleSelectProps {
    title?: string;
    options?: Options[];
    value?: number;
    onChange?: (value: { label: ReactNode; value_index: number; disabled?: boolean }) => void;
    extra?: ReactNode;
    attribute_code?: string;
}

const SingleSelect: FC<SingleSelectProps> = ({ title, options, value, onChange, extra, attribute_code }) => {
    const optionsSelected = options?.find((op) => op.value_index === value);
    return (
        <VariantItem title={title} value={optionsSelected?.label} extra={extra}>
            <div className={classNames('flex gap-2 flex-wrap', styles.single_select)}>
                {options?.map((op) => {
                    const swatchData = op.swatch_data;
                    if (swatchData?.value && swatchData.__typename === 'ImageSwatchData') {
                        return (
                            <img
                                title={op.label}
                                src={swatchData.value}
                                alt={op.label}
                                key={op.value_index + v4()}
                                className={classNames(styles.select_item, {
                                    [styles.selected]: op.value_index === value,
                                    [styles.disabled]: op.disabled
                                })}
                                onClick={() => onChange?.(op)}
                            />
                        );
                    }
                    return (
                        <Text
                            type="body-1"
                            key={op.value_index + v4()}
                            className={classNames(styles.select_item, {
                                [styles.selected]: op.value_index === value,
                                [styles.disabled]: op.disabled
                            })}
                            onClick={() => onChange?.(op)}
                        >
                            {op.label}
                        </Text>
                    );
                })}
            </div>
        </VariantItem>
    );
};

export default SingleSelect;
